import React from 'react';
import FourOhFour from '../FourOhFour/FourOhFour';

interface ErrorProps {
  error?: string;
  status?: number;
  link?: { to: string; title: string };
}

const Error: React.FC<ErrorProps> = ({
  error = "Uh oh, looks like we've encountered an error. Please try again later.",
  status = 0,
  link = { to: '', title: '' },
}) => (
  <FourOhFour status={status} error={error} link={link.to ? link : undefined} />
);

export default Error;
